import { ReactNode } from 'react';
import { Chip } from '@nextui-org/react';

interface HeaderProps {
  title: string;
  description?: string | ReactNode;
  /**
   * Action buttons or any React nodes that should appear to the right of the header
   * on large screens and below it on small screens.
   */
  actions?: ReactNode;
  /**
   * Optional element shown right next to the title (e.g. an info tooltip).
   */
  titleAddon?: ReactNode;
  /**
   * Optional additional classes for the root container.
   */
  className?: string;
  hasFrutic?: boolean;
  }

/**
 * Generic page header.
 *
 * - Mobile: stacks title/description and actions vertically.
 * - Desktop (md+): title/description on the left, actions on the right.
 */
const Header = ({ title, description, actions, titleAddon, className = '', hasFrutic = false }: HeaderProps) => {
  return (
    <div
      className={`flex flex-col gap-4 md:flex-row md:justify-between md:items-start mb-4 ${className}`}
    >
      <div className="flex flex-col flex-grow pr-4">
      <div className='flex gap-2 flex-col md:flex-row md:items-center mb-2'>
            <div className='flex items-center gap-2'>
              {/* design-ignore: este es el Header de página */}
              <h2 className='text-2xl font-bold text-foreground'>{title}</h2>
              {titleAddon}
            </div>{hasFrutic && (
              <Chip
                startContent={
                  <div className="relative">
                    <div className="absolute w-2 h-2 rounded-full bg-green-50 dark:bg-green-9500 animate-ping opacity-75" />
                    <div className="relative w-2 h-2 rounded-full bg-green-50 dark:bg-green-9500" />
                  </div>
                }
                variant="flat"
                color="success"
                className="text-green-800 font-medium px-3 py-2 bg-green-50 dark:bg-green-950 border border-green-200 shadow-sm hover:bg-green-100 transition-colors duration-200"
              >
                Portal Productores Conectado
              </Chip>
        )}
        </div>
        {description && <p className="text-default-500">{description}</p>}
      </div>

      {/* Actions */}
      {actions && (
        <div className="flex gap-2 flex-col md:flex-row w-full md:w-auto">
          {actions}
        </div>
      )}
    </div>
  );
};

export default Header; 